<div id="location-manager-location-list">
  <mat-radio-group [formControl]="locationForm">
    <small class="label">Selected Location</small>
    <mat-radio-button
      class="location"
      [value]="loadedLocation"
      (mouseenter)="locationMouseover.emit(loadedLocation)"
      (mouseleave)="locationMouseout.emit(loadedLocation)"
      [checked]="selectedLocation && selectedLocation.sublocations === null"
    >
      <div class="location-radio-content">
        <span class="location-text">
          <p>{{ getFormattedLocationDisplay(loadedLocation.display).line1 }}</p>
          <p>{{ getFormattedLocationDisplay(loadedLocation.display).line2 }}</p>
          <p class="gps">{{ formatGPSCoordinates({ lat: loadedLocation.latitude, lng: loadedLocation.longitude }) }}</p>
        </span>
        <button mat-icon-button [disabled]="true"><mat-icon class="material-icons-outlined">gps_fixed</mat-icon></button>
        &nbsp;
      </div>
    </mat-radio-button>
    <div *ngIf="loadedLocation.sublocations && loadedLocation.sublocations.length > 0" class="sublocations">
      <small class="label">Sub-Locations</small>
      <mat-radio-button
        class="sublocation"
        *ngFor="let sublocation of loadedLocation.sublocations"
        [value]="sublocation"
        (mouseenter)="locationMouseover.emit(sublocation)"
        (mouseleave)="locationMouseout.emit(sublocation)"
      >
        <div class="location-radio-content">
          <span class="location-text">
            {{ sublocation.name }}
          </span>
          <button mat-icon-button *appRequiresPermissions="{ any: ['location_management'] }" (click)="deleteSublocation.emit(sublocation)">
            <mat-icon class="material-icons-outlined">delete</mat-icon>
          </button>
          &nbsp;
        </div>
      </mat-radio-button>
    </div>
    <mat-form-field class="new-sublocation-form" *ngIf="addingNewLocation" appearance="outline">
      <input matInput type="text" placeholder="New location name" [formControl]="newLocationNameForm" />
    </mat-form-field>
    <div class="add-sublocation-actions" *appRequiresPermissions="{ any: ['location_management'] }">
      <button *ngIf="!addingNewLocation" mat-button color="primary" (click)="addNewLocation.emit()">
        <mat-icon>add</mat-icon>&nbsp;Add new sublocation
      </button>
      <button *ngIf="addingNewLocation" mat-raised-button (click)="cancelNewLocation.emit()">Cancel</button>
      <button *ngIf="addingNewLocation" mat-raised-button color="primary" (click)="saveNewLocation.emit(newLocationNameForm.value)">
        Save location
      </button>
    </div>
    <ng-container *ngIf="offsetLocationMode">
      <small class="label">Pin Location</small>
      <mat-radio-button *ngIf="mapCenterCoords" class="pin-location" [value]="geocodedOffsetLocation">
        <div class="location-radio-content">
          <span class="location-text">
            <p>{{ geocodedOffsetLocation ? getFormattedLocationDisplay(geocodedOffsetLocation.display).line1 : '--' }}</p>
            <p>{{ geocodedOffsetLocation ? getFormattedLocationDisplay(geocodedOffsetLocation.display).line2 : '--' }}</p>
            <p class="gps">{{ formatGPSCoordinates(mapCenterCoords) }}</p>
          </span>
        </div>
      </mat-radio-button>
    </ng-container>
  </mat-radio-group>
</div>
